import { TraitTypeSkeletonKey } from '../traitTypes/TraitTypeSkeletonKey';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryAspectStructure extends TraitRegistryCategory {
    label = 'Structure';
    constructor(parent) {
        super(parent);
        super.init();
    }
    structure = () => new TraitTypeSkeletonKey();
    wrapAspect = () => new TraitTypeSkeletonKey({
        multiple: true,
        customFilter: (skeletonItem) => skeletonItem.isAspectWrapper,
    });
    wrapChildren = () => new TraitTypeSkeletonKey({
        multiple: true,
    });
}
